import React from "react";
import Putf from "../../img/putf.png";
import { Link } from "react-router-dom";

const Putfirst = () => {
  return (
<div
  className="w-full place-content-center  place-items-center h-auto px-6 py-10 md:px-24 pb-40 md:pt-20 grid md:grid-cols-2 md:gap-12  gap-20 grid-cols-1"
  style={{
    background: "radial-gradient(93.96% 223.34% at -10.76% 33.62%, #07031C 0%, #241D49 30.52%, #07031C 64.32%)"
  }}
> 
      <div className="mt-[40px] md:mt-0">
        <h2 className=" md:text-[40px] text-[22px] font-[700]  text-white font-lato md:text-left text-center">
          {" "}
          Our <span className="text-[#F2C493]">Users</span> Come First
        </h2>
        <p className=" text-[#fff]  font-normal  text-[18px] font-istok mt-[50px]">
         At Capital Nest our users are at the core of everything we do. From day one, protecting your data has been our highest priority. That’s why we’ve implemented advanced security systems and rigorous data privacy protocols throughout the entire  Capital Nest ecosystem.
        </p>
     <Link
  to="/privacy"
  className="hidden   w-40 md:w-60 h-[50px] mt-4 md:mt-8 rounded-[15px] bg-[#D4F5F9] text-[#00001A] text-base md:text-lg font-istok-web font-medium md:grid place-items-center transition-all duration-300 hover:bg-[#D4F5F9] focus:outline-none focus:ring-2 focus:ring-[#D4F5F9] focus:ring-offset-2"
>
   View Security Statement
</Link>

      </div>
       <div>
        <img src={Putf} alt="" />
      </div>

      <Link  to="/privacy" className= " md:hidden  align-middle  self-center  w-[80%] md:w-60 h-[50px] mt-4 md:mt-8 rounded-[15px] bg-[#D4F5F9] text-[#00001A] text-base md:text-lg font-istok-web font-medium grid place-items-center transition-all duration-300 hover:bg-[#D4F5F9] focus:outline-none focus:ring-2 focus:ring-[#D4F5F9] focus:ring-offset-2">
     View Security Statement
      </Link>

    </div>
  );
};

export default Putfirst;
